import { Box } from '@mui/material';
import {
  KeyboardDoubleArrowUp as KeyboardDoubleArrowUpIcon,
  KeyboardArrowUp as KeyboardArrowUpIcon,
} from '@mui/icons-material';

export const PriorityIcon = ({ priority }: { priority: string }) => {
  const priorityLower = priority.toLowerCase();
  
  let icon = null;
  let bgcolor = 'success.main';
  
  if (priorityLower === 'high') {
    icon = <KeyboardDoubleArrowUpIcon sx={{ color: 'white', fontSize: 20 }} />;
    bgcolor = 'error.main';
  } else if (priorityLower === 'medium') {
    icon = <KeyboardArrowUpIcon sx={{ color: 'white', fontSize: 20 }} />;
    bgcolor = 'warning.main';
  } else if (priorityLower === 'low') {
    icon = (
      <Box
        sx={{
          bgcolor: 'white',
          borderRadius: '50%',
          width: 10,
          height: 10,
        }}
      />
    );
    bgcolor = 'success.main';
  }
  
  return (
    <Box
      sx={{
        bgcolor: bgcolor,
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: 27,
        height: 27,
        ml: 2,
        mt: 0.5,
      }}
    >
      {icon}
    </Box>
  );
};
